import { DatePipe, SlicePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import { Moment } from 'moment';

@Pipe({
    name: 'simpleDate'
})
export class SimpleDatePipe implements PipeTransform {
    //   transform(value: unknown, ...args: unknown[]): unknown {
    //     return null;
    //   }
    transform(value: string | Date | Moment, arg?: string): any {
        let val: string = String(value);
        let slicedValue: string;

        arg = arg ? arg : 'MM/dd/yyyy';

        if (val.substring(0, 1) === '/D' || val.substring(0, 1) === '/d') {
            slicedValue = new SlicePipe().transform(val, 6, -2);
            let returnDate = new DatePipe('en-US').transform(new Date(parseInt(slicedValue)), arg);
            if (returnDate === '01/01/1900') {
                return '';
            } else {
                return returnDate;
            }
        } else if (!moment(val).isValid()) {
            return '';
        } else {
            slicedValue = val;
            let returnDate = new DatePipe('en-US').transform(new Date(slicedValue), arg);
            if (returnDate === '01/01/1900') {
                return '';
            } else {
                return returnDate;
            }
        }
    }
}
